export default "__VITE_ASSET__CrlZ_8sa__"